import axios from 'axios'

const service = axios.create({
    timeout: 3600000,  // 1 hour in milliseconds
    // baseURL: process.env.VUE_APP_BASE_API, // uncomment and set if you have a base URL
})

// Request interceptor
service.interceptors.request.use(
    config => {
        // You can add auth tokens or other request modifications here
        return config;
    },
    error => {
        console.error('Request error:', error.message);
        return Promise.reject(error);
    }
);

// Response interceptor
service.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        // Axios errors include request bodies, which may contain passwords.
        console.error('Response error:', error.message);
        return Promise.reject(error);
    }
);

export default service